// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bad82f7","455":"792685e7","977":"11d2ceb2"}[chunkId] + ".chunk.js";
};